import cn from 'classnames'
import getHeight from 'dom-helpers/height'
import qsa from 'dom-helpers/querySelectorAll'
import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'

import * as dates from 'react-big-calendar/lib/utils/dates'
import CustomEventRow from './CustomEventRow'
import {getSlotMetrics} from '../../utils/getSlotMetrics';
import CustomCalendarCells from './CustomCalendarCells';

export default class CustomDateHeaderRow extends React.Component {
	constructor(...args) {
		super(...args)

		this.slotMetrics = getSlotMetrics()
	}

	handleSelectSlot = slot => {
		const { range, onSelectSlot } = this.props

		onSelectSlot(range.slice(slot.start, slot.end + 1), slot)
	}

	handleShowMore = (slot, target) => {
		const { range, onShowMore } = this.props
		let metrics = this.slotMetrics(this.props)
		let row = qsa(findDOMNode(this), '.rbc-row-bg')[0]

		let cell
		if (row) cell = row.children[slot - 1]

		let events = metrics.getEventsForSlot(slot)
		onShowMore(events, range[slot - 1], cell, slot, target)
	}

	createHeadingRef = r => {
		this.headingRow = r
	}

	createEventRef = r => {
		this.eventRow = r
	}

	getContainer = () => {
		const { container } = this.props
		return container ? container() : findDOMNode(this)
	}

	getRowLimit() {
		let eventHeight = getHeight(this.eventRow)
		let headingHeight = this.headingRow ? getHeight(this.headingRow) : 0
		let eventSpace = getHeight(findDOMNode(this)) - headingHeight

		return Math.max(Math.floor(eventSpace / eventHeight), 1)
	}

	renderHeadingCell = (date, index) => {
		let { renderHeader, getNow } = this.props

		return renderHeader({
			date,
			key: `header_${index}`,
			className: cn(
				'rbc-date-cell',
				dates.eq(date, getNow(), 'day') && 'rbc-now'
			),
		})
	}

	renderDummy = () => {
		let { className, range, renderHeader } = this.props
		return (
			<div className={className}>
				<div className="rbc-row-content">
					{renderHeader && (
						<div className="rbc-row " ref={this.createHeadingRef}>
							{range.map(this.renderHeadingCell)}
						</div>
					)}
				</div>
			</div>
		)
	}

	render() {
		const {
			date,
			rtl,
			range,
			className,
			selected,
			selectable,
			renderForMeasure,
			accessors,
			getters,
			components,
			getNow,
			onSelect,
			localizer,
			onSelectStart,
			onSelectEnd,
			onDoubleClick,
			resourceId,
			longPressThreshold,
		} = this.props

		if (renderForMeasure) return this.renderDummy()

		let metrics = this.slotMetrics(this.props)
		let { levels } = metrics

		const eventRowProps = {
			selected,
			accessors,
			getters,
			localizer,
			components,
			onSelect,
			onDoubleClick,
			resourceId,
			slotMetrics: metrics,
		}

		return (
			<div className={className}>
				<CustomCalendarCells
					date={date}
					className={'calendar-cell'}
					getNow={getNow}
					rtl={rtl}
					range={range}
					selectable={selectable}
					container={this.getContainer}
					getters={getters}
					onSelectStart={onSelectStart}
					onSelectEnd={onSelectEnd}
					onSelectSlot={this.handleSelectSlot}
					components={components}
					longPressThreshold={longPressThreshold}
				/>
				<div className={cn("rbc-row-content", 'view__events-row')}>
					{levels.map((segs, idx) => {
						return (
						<CustomEventRow key={idx} segments={segs} {...eventRowProps} />
					)})}
					<div className="view__event-tooltip"></div>
				</div>
			</div>
		)
	}
}

CustomDateHeaderRow.propTypes = {
	date: PropTypes.instanceOf(Date),
	events: PropTypes.array.isRequired,
	range: PropTypes.array.isRequired,

	rtl: PropTypes.bool,
	resourceId: PropTypes.any,
	renderForMeasure: PropTypes.bool,
	renderHeader: PropTypes.func,

	container: PropTypes.func,
	selected: PropTypes.object,
	selectable: PropTypes.oneOf([true, false, 'ignoreEvents']),
	longPressThreshold: PropTypes.number,

	onShowMore: PropTypes.func,
	onSelectSlot: PropTypes.func,
	onSelect: PropTypes.func,
	onSelectEnd: PropTypes.func,
	onSelectStart: PropTypes.func,
	onDoubleClick: PropTypes.func,
	dayPropGetter: PropTypes.func,

	getNow: PropTypes.func.isRequired,
	isAllDay: PropTypes.bool,

	accessors: PropTypes.object.isRequired,
	components: PropTypes.object.isRequired,
	getters: PropTypes.object.isRequired,
	localizer: PropTypes.object.isRequired,

	minRows: PropTypes.number.isRequired,
	maxRows: PropTypes.number.isRequired,
}

CustomDateHeaderRow.defaultProps = {
	minRows: 0,
	maxRows: Infinity,
}
